 

 <nb-card style="position:relative" >
              
   <nb-card-header>
            
  		<div style="display:flex; width:100%">
		        <span>Ретрансляції</span>   
		         <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="closeModal()">
				<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
			</span>  
                </div>

           </nb-card-header> 
        <nb-card-body>

             
<div class="wrapper"  *ngIf="stream" > 
    
    <div>

 
        <div class="restreamsItems scrollable-container">

        <div *ngFor="let restream of restreams; let i = index" class="item">
           
            <div  style="display:flex; width: 20px;">
                <span style="margin:auto;">{{i+1}}.</span>
            </div>
           

	<div class="elems">
           <div>
               <input  placeholder="RTMP URL" [(ngModel)]="restream.url" nbInput type="text" />
               <div class="text-danger" *ngIf="restream.errorUrl">{{restream.errorUrl}}</div>
           </div> 

            
            
           <div >
            <input  placeholder="Ключ" nbInput [(ngModel)]="restream.key" type="text" />
            <div class="text-danger" *ngIf="restream.errorKey">{{restream.errorKey}}</div>

        </div> 

        <div  style="display:none" class="toggle">
            <nb-toggle  [(checked)]="restream.active" status="primary"></nb-toggle>

        </div>

         
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restream.login" type="text" />
            <div class="text-danger" *ngIf="restream.errorLogin">{{restream.errorLogin}}</div>

        </div> 

         
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restream.password" type="text" />
            <div class="text-danger" *ngIf="restream.errorPassword">{{restream.errorPassword}}</div>

        </div> 

        </div> 



        </div>
    </div>


    </div>
 

</div> 

 
</nb-card-body>
<nb-card-footer>

        <div style="display: flex;">
            <div style="display: flex; margin-left: auto;">
 
           <button nbButton (click)="save()" status="success">Зберегти </button>
           <button nbButton style="margin-left: 10px;" (click)="closeModal()">Скасувати </button>
            </div>
        </div>

    <div *ngIf="loading" style="position: absolute; z-index: 777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>


</nb-card-footer>
</nb-card>



     



